(function () {
	'use strict';

	angular
		.module('app', ['ui.router', 'ui.router.state.events', 'ui.bootstrap', 'pascalprecht.translate',
			'ngFileUpload', 'ngSanitize', 'exceptionHandlerOverride', 'mainDashboard',
			'workerStatusModule',
			'changePasswordModule', 'createFactoryModule',
			'cloneSettingsModule', 'userManagementModule',
			'businessAnalytics',
			'configureSupplierPerformanceModule', 'app.core', 'app.dashboard',
			'app.setup', 'app.supplyChain', 'app.leanProjects', 'app.myWork',
			'directives', 'services'
		]).config(['uiSelectConfig', function(uiSelectConfig) {
			uiSelectConfig.spinnerClass = '';
		}])
		.run(runBlock);

	runBlock.$inject = ['$rootScope', '$window', '$timeout', '$location', '$uibModal', '$uibModalStack', '$state', '$filter', 'pageTimingService',
		'navigationService', 'leanFilterService', 'weeklyLogItemService', 'userService', 'leanTableConfigService', 'storeService', '$experiments', 'notificationService', 'userAttributes', 'siteService'];

	function runBlock($rootScope, $window, $timeout, $location, $uibModal, $uibModalStack, $state, $filter, pageTimingService,
			navigationService, leanFilterService, weeklyLogItemService, userService, leanTableConfigService, storeService, $experiments, notificationService, userAttributes, siteService) {
		var momentLocale = (globalConfig.browser.locale || 'en-us').replace('_', '-').toLowerCase();

		// Define a custom "la" (Latin) locale for testing - matches the ^^áccéntéd^^ pattern used in locale-la.json
		if (momentLocale === 'la') {
			moment.defineLocale('la', {
				relativeTime: {
					future: '^^ín %s^^',
					past: '^^%s ágó^^',
					s: '^^á féw sécónds^^',
					ss: '^^%d sécónds^^',
					m: '^^á mínúté^^',
					mm: '^^%d mínútés^^',
					h: '^^án hóúr^^',
					hh: '^^%d hóúrs^^',
					d: '^^á dáy^^',
					dd: '^^%d dáys^^',
					w: '^^á wéék^^',
					ww: '^^%d wééks^^',
					M: '^^á mónth^^',
					MM: '^^%d mónths^^',
					y: '^^á yéár^^',
					yy: '^^%d yéárs^^'
				}
			});
		}

		moment.locale(momentLocale);

		// Makes navigation available across the app
		$rootScope.goToState = navigationService.goToState;
		$rootScope.goToTabFirstView = navigationService.goToTabFirstView;
		$rootScope.isSupplierPreview = globalConfig.user.supplierView && globalConfig.user.supplierView.switchType &&
		globalConfig.user.supplierView.switchType === 'SUPPLIER';
		// to select nav vs mobile nav
		$rootScope.windowWidth = $window.innerWidth;
		angular.element($window).bind('resize', function() {
			$rootScope.isMobile = $window.innerWidth < 1024;
		});
		
		var adminConfig = getAdminConfig();
		storeService.dispatch(storeService.actionCreators.setGlobalConfig(_.cloneDeep(globalConfig)));
		storeService.dispatch(storeService.actionCreators.setExperimentConfig($experiments.getAll()));
		storeService.dispatch(storeService.actionCreators.setAdminFactoryConfig({
			factory: adminConfig
		}));
		storeService.dispatch(storeService.actionCreators.setAdminCustomerConfig({
			customer: {
				id: globalConfig.customer.id,
				name: globalConfig.customer.name
			}
		}));
		var SUPPLIER_TOS_VERSION = '2026-10';
		if (globalConfig.user.role === 'Supplier') {
			storeService.dispatch(storeService.actionCreators.getUserAchievements()).then(function (_) {
				storeService.dispatch(storeService.actionCreators.addUserAchievementActivity({activityType: 'daily_login'}));
			});
			showSupplierTosModal();
		}

		if (authorize(['filters', 'poStatusCategories'])) {
			storeService.dispatch(storeService.actionCreators.getPOStatusCategory());
		}

		// temporary permission handling of the root cause category api.  Maybe look for a better solution after hotfix.
		if (authorize(['filters', 'currentShortageRootCauseCategories']) &&
				(globalConfig.user.role !== 'Supplier' || globalConfig.customer.supplierComponents.indexOf('LINE_OF_BALANCE') !== -1)) {
			storeService.dispatch(storeService.actionCreators.getCurrentShortageRootCauseCategories());
		}

		if (globalConfig.user.role !== 'Supplier' && (!globalConfig.user.supplierView || globalConfig.user.supplierView.switchType === 'REGULAR')) {
			if (authorize(['filters', 'shortageCriticalityLevels'])) {
				storeService.dispatch(storeService.actionCreators.getCriticalShortageLevel());
			}
			if (authorize(['filters', 'erpOrderPolicy'])) {
				storeService.dispatch(storeService.actionCreators.getOrderPolicyLookup());
			}
			if (authorize(['filters', 'task'])) {
				storeService.dispatch(storeService.actionCreators.getTaskCategoriesForCustomer());
			}
			if (authorize(['filters', 'supplier'])) {
				storeService.dispatch(storeService.getSuppliers({
					factoryNdx: 'LDNA_A_S'
				}));
			}
		}

		if (globalConfig.user.role !== 'Supplier') {
			storeService.dispatch(storeService.actionCreators.getFavorites());
		}

		if (!(globalConfig.user.supplierView && globalConfig.user.supplierView.switchType === 'SUPPLIER')) {

			storeService.dispatch(storeService.actionCreators.fetchGroups());
		}

		$rootScope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
			$rootScope.previousState = from;
			if ($rootScope.refreshPage) {
				$rootScope.refreshPage = false;
				$window.location.reload();
			}

			var firstViewTabs = ['workbench', 'my-work', 'dashboard', 'user-achievements', 'supply-chain', 'factory', 'lean-projects', 'company-setup', 'site-setup', 'leandna-setup', 'account'];
			var excludedSubviews = ['project-templates-tasks', 'data-pipeline-health-check', 'data-pipeline-health-check-trend', 'data-pipeline-health-check-history', 'unsubscribe-email', 'report-list', 'create-report', 'favorites', 'setup'];
			var routeParts = /app.([^\.]*).(.*)/.exec(to.name);
			if (routeParts && routeParts[1] && routeParts[2]) {
				var selectedTab = routeParts[1];
				var selectedView = routeParts[2];
				var savedViewId = toParams.reportId || toParams.id;
				if(firstViewTabs.indexOf(selectedTab) > -1 && excludedSubviews.indexOf(selectedView) === -1) {
					storeService.setFirstView(selectedTab, 'customer', selectedView, savedViewId);
				}
			}
		});
		storeService.loadFirstViews(globalConfig.factory.id);

		$rootScope.$on('$stateChangeStart', function (event, to, toParams, from, fromParams) {
			// 5653: fix some faulty links in marketing email
			if ($location.absUrl().indexOf('utm_campaign=Customer_Updates') >= 0) {
				if (window.location.hash && window.location.hash.indexOf('/dashboard/348') >= 0) {
					$window.location.href = 'https://www.leandna.com/knowledge-base/control-tower-dashboard/';
				}
				var hashString = location.hash;
				if (hashString.indexOf('&factory=172') >= 0) {
					$timeout(function() {
						// Clear the factory qparam
						hashString = hashString.replace('&factory=172','');
						window.location.hash = hashString;
						location.reload();
					}, 0);
				}
			}

			var byEmail = /byEmail=1/.test(window.location.hash),
				switchToSite = /factoryNdx=(\d+)/.exec(window.location.hash),
				emailType = /emailType=([^&]+)/.exec(window.location.hash),
				siteId;
			if (byEmail && switchToSite !== null) {
				siteId = switchToSite[1];
				if (globalConfig.factory.id != siteId) {
					userService.switchSite(encodeURIComponent(siteId), true);
				} else {
					$timeout(function() {
						// Clear the byEmail qparam
						window.location.hash = window.location.hash.replace(/&?byEmail=1/,'');
					}, 0);
				}
			}

			var toastMessage = $location.search() && $location.search().toastMessage;
			if (toastMessage && toastMessage.length) {
				var timeout = $location.search().toastTimeout ? $location.search().toastTimeout : undefined;
				$rootScope.$emit('toast', {
					'message': toastMessage,
					'success': true,
					'time': timeout
				});
				$location.search('toastMessage', null);
				$location.search('toastTimeout', null);
			}

			var errorMessage = $location.search() && $location.search().errorToast;
			if (errorMessage && errorMessage.length) {
				var timeout = $location.search().toastTimeout ? $location.search().toastTimeout : undefined;
				$rootScope.$emit('toast', {
					'message': errorMessage,
					'success': false,
					'time': timeout
				});
				$location.search('errorToast', null);
				$location.search('toastTimeout', null);
			}

			weeklyLogItemService.clearData(true);
			leanTableConfigService.setMandatoryDefaultFilters(false);
			// Make site filter removable for all reports that aren't my assignments
			if (to && to.name && to.name.indexOf('app.my-assignments') < 0) {
				var siteFilter = leanFilterService.filterDefinitions['Factory'];
				siteFilter.removable = true;
			}

			// Reset filter label to default for customer success sites and all sites
			leanFilterService.filterDefinitions['AllCustomerFactories'].label = 'factoryAlias';
			leanFilterService.filterDefinitions['AllFactories'].label = 'name';

			// Reset Task Responsible Filter
			leanFilterService.filterDefinitions['Responsible'].displayName = 'Task Responsible';

			leanFilterService.filterDefinitions['ShortageCriticalityLevel'].tooltip = undefined;
			leanFilterService.filterDefinitions['Factory'].sboType = undefined;

			if (to.redirectTo) {
				if (to.redirectTo === 'childState') {
					if (to.data && to.data.viewType) {
						var viewType = to.data.viewType;
						var state;
						var data = navigationService.getFirstView(viewType);
						var viewMappingInfo = navigationService.getViewMappings()[viewType];
						if (viewMappingInfo && viewMappingInfo[data.reportName]) {
							state = viewMappingInfo[data.reportName].sref;
						}
						if (state) {
							// wrap the state change in timeout to make sure current state is complete before loading the new state
							$timeout(function () {
								$state.go(state, undefined, { location: 'replace' });
							}, 0);
						} else {
							var defaultState = navigationService.getDefaultView(viewType);
							state = navigationService.getViewMappings()[viewType][defaultState.reportName].sref;
							if (state) {
								// wrap the state change in timeout to make sure current state is complete before loading the new state
								$timeout(function () {
									$state.go(state, undefined, { location: 'replace' });
								}, 0);
							}
						}
					}
				}
			}
			// We want the dashboard load to be timed together, not split because we have an internal redirect from #/ -> #/dashboard -> #/dashboard/{id}
			if (!(from.name === '' && to.name === 'app.dashboard')
				&& !(from.name === '' && to.name === 'app.my-assignments')) {
				pageTimingService.clearAllStartTimes();
				pageTimingService.setLoadStartTime(to.data.timingName, pageLoadStartTime, to.data.doTiming);
				pageLoadStartTime = undefined;
			}
			var top = $uibModalStack.getTop();
			// Route changes dismiss the open modal. The supplier TOS modal stays until the user agrees.
			if (top && !(top.value.modalScope && top.value.modalScope.supplierTosRequired)) {
				$uibModalStack.dismiss(top.key);
			}

		});

		function setTaskNewValuesBasedOnChanges(task, field, value, newValues) {
			switch (field) {
			case 'status':
				if (task.statusName === 'Open') {
					newValues.unableToFixComment = '';
					newValues.dateCompleted = undefined;
					newValues.unableToFixCategoryName = '';
					newValues.actionReviewLaterExpireDate = undefined;
				} else {
					newValues.isReassign = 0;
				}
				newValues.status = strip(task.statusName);
				newValues.actionStatus = newValues.status;
				newValues.actionStatusNdx = task.statusNdx;
				newValues.iaStatusNdx = task.statusNdx;
				newValues.actionReviewLaterExpireDate = task.reviewLaterExpireDate ? parseInt(strip(task.reviewLaterExpireDate)) : undefined;
				newValues.completedDate = task.completedDate ? $filter('dateYearFirst')(task.completedDate) : '';
				newValues.actionCompletedDate = newValues.completedDate;
				break;
			case 'responsible':
				newValues.responsibleName = strip(task.ownerFirstName + ' ' + task.ownerLastName);
				newValues.iaTaskOwner = newValues.responsibleName;
				newValues.actionOwner = newValues.responsibleName;
				newValues.actionOwnerNdx = task.ownerNdx;
				newValues.iaTaskOwnerNdx = newValues.actionOwnerNdx;
				newValues.responsibleNdx = newValues.actionOwnerNdx;
				break;
			case 'category':
				newValues.actionCategory = strip(task.categoryDisplayName);
				newValues.actionCategoryNdx = task.categoryNdx;
				break;
			case 'dueDate':
				newValues.actionDueDate = new Date(task.dueDate).getTime();
				break;
			case 'subject':
				newValues.actionSubject = task.subject;
				break;
			case 'description':
				newValues.actionDescription = task.description;
				break;
			}
		}

		function postEditAction(actionHolder, taskChanges) {
			var updateRowsObject = {};
			updateRowsObject.identifier = {
				taskId: actionHolder.id
			};
			updateRowsObject.newValues = {
				lastActivityTimestamp: parseInt(strip(actionHolder.lastModifiedDate))
			};

			angular.forEach(taskChanges, function (change) {
				setTaskNewValuesBasedOnChanges(actionHolder, change.field, change.value, updateRowsObject.newValues);
			});

			$rootScope.$broadcast('updateRows', updateRowsObject);
			//only call the service if the tasks updates are coming from my work
			if (($location.url()).indexOf('/my-work') !== -1) {
				notificationService.getUnreadInventoryActions(true);
			}
		}

		function postNewAction(actionHolder) {
			var updateRowsObject = {};
			var dueDate = new Date(actionHolder.dueDate);
			updateRowsObject.identifier = {
				itemNdx: actionHolder.itemNdx
			};
			// Merge actionCount against the existing row so Task Status shows the multi-task badge (React parity).
			updateRowsObject.incrementActionCount = true;
			updateRowsObject.newValues = {
				lastActivityTimestamp: parseInt(strip(actionHolder.lastModifiedDate))
			};
			// Update the rows variables
			updateRowsObject.newValues.actionStatus = actionHolder.statusName;
			updateRowsObject.newValues.actionStatusNdx = actionHolder.statusNdx;
			updateRowsObject.newValues.responsibleName = strip(actionHolder.ownerFirstName + ' ' + actionHolder.ownerLastName);
			updateRowsObject.newValues.actionOwner = updateRowsObject.newValues.responsibleName;
			updateRowsObject.newValues.actionOwnerNdx = actionHolder.ownerNdx;
			updateRowsObject.newValues.actionSubject = actionHolder.subject;
			updateRowsObject.newValues.actionDescription = actionHolder.description;
			updateRowsObject.newValues.responsibleNdx = actionHolder.ownerNdx;
			updateRowsObject.newValues.actionDueDate = dueDate.getTime();
			updateRowsObject.newValues.actionIsActive = true;
			updateRowsObject.newValues.taskId = actionHolder.id;
			updateRowsObject.newValues.actionCategory = actionHolder.categoryName;
			updateRowsObject.newValues.actionCategoryNdx = actionHolder.categoryNdx;
			updateRowsObject.newValues.lastComment = '';
			updateRowsObject.newValues.lastCommentDate = undefined;
			updateRowsObject.newValues.lastCommenter = '';
			$rootScope.$broadcast('updateRows', updateRowsObject);
			//only call the service if the tasks updates are coming from my work
			if (($location.url()).indexOf('/my-work') !== -1) {
				notificationService.getUnreadInventoryActions(true);
			}
		}

		var args = [];
		var updateRowsLater = _.debounce(function() {
			$rootScope.$broadcast('updateRows', args);
			args = [];
		}, 1000, false);
		var updateRowsDebounced = function(updateRowsObject) {
			args.push(updateRowsObject);
			updateRowsLater();
		};

		storeService.subscribe(function() {
			var state = storeService.getState();
			var chatActions = [
				'chat/getWatchedChatsForCurrentUser/fulfilled',
				'chat/addWatcherToChatById/fulfilled',
				'chat/deleteWatcherFromChatById/fulfilled'
			];
			if(chatActions.includes(state.previousAction.type)) {
				var watchedChats = state.chat.watchedChats;

				$rootScope.$broadcast('updateChatWatchers', watchedChats);
			}
		});

		storeService.subscribe(function() {
			var state = storeService.getState();
			var chatActions = [
				'chat/updateLastActivityByChatId',
				'chat/putToChannelByChatId'
			];
			if(chatActions.includes(state.previousAction.type)) {
				var updateRowsObject = {};
				var chatId = state.previousAction.payload.chatId;
				var chatObj = state.chat.currentChats[chatId];

				if(chatObj) {
					updateRowsObject.useChatIdentifier = true;
					updateRowsObject.chatId = chatId;
	
					var chatStatus = leanTableConfigService.getChatStatus(state.chat.currentChats[chatId]);
	
					if (chatStatus) {
						updateRowsObject.newValues = {
							chatLastActivity: state.chat.currentChats[chatId].lastActivity,
							chatStatus: chatStatus
						};
	
						updateRowsDebounced(updateRowsObject);
					}
				}
			}
		});

		storeService.subscribe(function () {
			var state = storeService.getState();
			if (state.previousAction.type === 'procurementTask/updateTask/fulfilled'
				&& (state.reportSettings.reportName === globalReportName
					|| state.reportSettings.reportSettingsId === globalReportName)) {
				postEditAction(state.previousAction.payload, state.previousAction.meta.arg.changes);
			}
		});

		storeService.subscribe(function() {
			var state = storeService.getState();
			if(state.previousAction.type.match('chat/addMessageToChannelByChatId')) {
				var payload = state.previousAction.payload;
				if (payload.message.timestamp) {
					var updateRowsObject = {
						useChatIdentifier: true,
						chatId: payload.chatId
					};
					updateRowsObject.identifier = {};
					updateRowsObject.newValues = {};
					updateRowsObject.newValues.chatLastActivity = payload.message.timestamp;
					updateRowsObject.newValues.chatIsRead = true;
					updateRowsDebounced(updateRowsObject);
				}
			}
		});

		storeService.subscribe(function () {
			var state = storeService.getState();
			if (state.previousAction.type === 'procurementTask/archiveTask/fulfilled'
				&& (state.reportSettings.reportName === globalReportName
					|| state.reportSettings.reportSettingsId === globalReportName)) {
				var updateRowsObject = {};
				updateRowsObject.identifier = {
					taskId: state.previousAction.payload
				};
				updateRowsObject.newValues = {};
				updateRowsObject.newValues.actionIsActive = false;
				updateRowsObject.newValues.actionStatusIcon = 'fa fa-plus task-status-none';
				updateRowsObject.newValues.actionStatus = 'Archived';
				updateRowsObject.newValues.actionStatusTip = '';
				$rootScope.$broadcast('updateRows', updateRowsObject);
			}
			if (state.previousAction.type === 'leanTableData/update-po-comment/fulfilled') {
				var updateRowsObject = {};
				if (state.previousAction.payload.rowDataUpdates.poStatusCategoryDescription  === 'None') {
					state.previousAction.payload.rowDataUpdates.poStatusCategoryDescription = '';
				}
				if (state.reportSettings.reportName === 'purchase-orders') {
					updateRowsObject.identifier = {
						itemNdx: state.previousAction.payload.data.itemNdx,
						orderNumber: state.previousAction.payload.data.poNumber,
						scheduleLine: state.previousAction.payload.data.scheduleLine,
						orderLine: state.previousAction.payload.data.poLine
					};
				}
				else if (state.reportSettings.reportName === 'material-shortages/shortages-by-order') {
					updateRowsObject.identifier = {
						itemNdx: state.previousAction.payload.data.itemNdx,
						purchaseOrderNumber: state.previousAction.payload.data.poNumber,
						scheduleLine: state.previousAction.payload.data.scheduleLine,
						purchaseOrderLine: state.previousAction.payload.data.poLine
					};
				}
				else {
					updateRowsObject.identifier = {
						itemNdx: state.previousAction.payload.data.itemNdx,
						firstPurchaseOrderNumber: state.previousAction.payload.data.poNumber,
						firstPurchaseOrderScheduleLine: state.previousAction.payload.data.scheduleLine,
						firstPurchaseOrderLine: state.previousAction.payload.data.poLine
					};
				}
				updateRowsObject.newValues = state.previousAction.payload.rowDataUpdates;
				updateRowsDebounced(updateRowsObject);
			};
		});

		storeService.subscribe(function () {
			var state = storeService.getState();
			if (state.previousAction.type === 'procurementTask/addTask/fulfilled'
				&& (!state.reportSettings.reportName
					|| state.reportSettings.reportName === globalReportName
					|| state.reportSettings.reportSettingsId === globalReportName)) {
				postNewAction(state.previousAction.payload);
			}
		});

		// When React Add Task refreshes row rollups (actionCount / multi-task lists), apply them to the Angular table.
		storeService.subscribe(function () {
			var state = storeService.getState();
			if (state.previousAction.type !== 'leanTableData/update-row-Data-for-task/fulfilled') {
				return;
			}
			var payload = state.previousAction.payload;
			if (!payload || !payload.updateCount || !payload.rowDataUpdates) {
				return;
			}
			if (state.reportSettings.reportName
				&& state.reportSettings.reportName !== globalReportName
				&& state.reportSettings.reportSettingsId !== globalReportName) {
				return;
			}
			var itemNdx = payload.rowDataUpdates.itemNdx;
			if (!itemNdx && state.procurementTasks && state.procurementTasks.entities) {
				var taskEntity = state.procurementTasks.entities[payload.taskId];
				if (taskEntity) {
					itemNdx = taskEntity.itemNdx;
				}
			}
			if (!itemNdx) {
				return;
			}
			// Angular Task Status is procurement-only (same as report load / isSystemGenerated = 0).
			// React updateRowDataForTask sets actionCount to open+recently-done including inventory
			// actions; prefer taskCount so adding tasks does not jump (e.g. 1 then 3 with an open IA).
			var newValues = angular.extend({}, payload.rowDataUpdates);
			if (newValues.taskCount != null && newValues.taskCount !== '') {
				newValues.actionCount = newValues.taskCount;
				newValues.numTasks = newValues.taskCount;
			}
			$rootScope.$broadcast('updateRows', {
				identifier: { itemNdx: itemNdx },
				newValues: newValues
			});
		});

		function showSupplierTosModal() {
			if (globalConfig.user.isImpersonated || userAttributes.get('supplierTosVersion') === SUPPLIER_TOS_VERSION) {
				return;
			}

			var modalScope = $rootScope.$new();
			modalScope.supplierTosRequired = true;
			modalScope.agreeing = false;

			var supplierTosModal = $uibModal.open({
				scope: modalScope,
				templateUrl: '/application/f/core/navigation/supplier-tos-modal.html',
				backdrop: 'static',
				keyboard: false,
				windowClass: 'uib-modal-z-above-pendo',
				backdropClass: 'uib-modal-backdrop-z-above-pendo'
			});

			modalScope.agree = function () {
				if (modalScope.agreeing) {
					return;
				}
				modalScope.agreeing = true;
				userAttributes.set({
					supplierTosVersion: SUPPLIER_TOS_VERSION,
					supplierTosAcceptedAt: new Date().toISOString()
				}, true).then(function () {
					modalScope.supplierTosRequired = false;
					supplierTosModal.close();
				}, function () {
					modalScope.agreeing = false;
					$rootScope.$emit('toast', {
						message: 'Could not save your agreement. Please try again.',
						success: false
					});
				});
			};
		}

		function getAdminConfig() {
			var selectedAdminSite = {
				id: globalConfig.factory.id,
				name: globalConfig.factory.alias || globalConfig.factory.name
			};

			var HASH_PREFIX_USER_ATTRIBUTES = 'ass';
			var userAttributeValue = userAttributes.getHashed(HASH_PREFIX_USER_ATTRIBUTES, 'customer-' + globalConfig.customer.id);

			if (userAttributeValue && _.some(siteService.getAdminSitesByCustomer(globalConfig.customer.id), ['id', userAttributeValue])) {
				var authorizedSite = globalConfig.user.authFacts[userAttributeValue];
				selectedAdminSite.id = authorizedSite.ndx;
				selectedAdminSite.name = authorizedSite.alias || authorizedSite.name;
			} else {
				var adminSites = siteService.getAdminSitesByCustomer(globalConfig.customer.id);
				if (adminSites.length) {
					var authorizedSite = globalConfig.user.authFacts[adminSites[0].id];
					selectedAdminSite.id = authorizedSite.ndx;
					selectedAdminSite.name = authorizedSite.alias || authorizedSite.name;
				}
			}

			return selectedAdminSite;
		}
	}

})();
